<template>
    <Suspense>
        <AppWithContext />
        <template #fallback>
            <FullscreenLoader />
        </template>
    </Suspense>
</template>
